module.exports = __webpack_public_path__ + "img/wm-rack2.39848a1b.svg";